import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

import {
  getToneClasses,
  type SemanticTone,
  type ToneIntensity,
} from "./tone-styles"

export function EmptyState({
  icon,
  tone = "primary",
  intensity = "subtle",
  title,
  description,
  actions,
  className,
}: {
  icon: ReactNode
  tone?: SemanticTone
  intensity?: ToneIntensity
  title: string
  description?: string
  actions?: ReactNode
  className?: string
}) {
  const toneClasses = getToneClasses(tone, intensity)

  return (
    <div
      className={cn(
        "mx-auto grid max-w-xl gap-3 rounded-2xl border border-dashed border-border/70 bg-card/35 p-5 text-center",
        className,
      )}
    >
      <div
        className={cn(
          "mx-auto flex size-11 items-center justify-center rounded-full border",
          toneClasses,
        )}
      >
        {icon}
      </div>
      <div className="space-y-1">
        <p className="text-base font-semibold text-foreground">{title}</p>
        {description ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  )
}
